import {
  selectUserReceivedRequests,
  selectUserRole,
} from "@utils/redux-utils/selectors/userSelectors";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Submission, SubmissionType } from "types/userTypes";
import { SubmissionItem } from "./submissionItem";
import { Container, Text, Stack, Accordion, Group, Badge, Box } from "@mantine/core";
import { requestFetchSubmissions } from "@actions/userActions";
import { useTranslation } from "react-i18next";
import { getSubmissionTypeLabel } from "@utils/UIUtils";

const SubmissionsList: React.FC = (_props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const receivedSubmissions: Submission[] = useSelector(selectUserReceivedRequests);
  const role = useSelector(selectUserRole);

  useEffect(() => {
    dispatch(requestFetchSubmissions());
  }, [dispatch]); // Added dispatch to dependency array

  const submissionsArray = Array.isArray(receivedSubmissions)
    ? receivedSubmissions
    : receivedSubmissions
      ? [receivedSubmissions]
      : [];

  const pendingSubmissions = submissionsArray.filter((submission) => !submission.isApproved);

  const submissionsByType = pendingSubmissions.reduce(
    (grouped, submission) => {
      const type = submission.type;
      if (!grouped[type]) {
        grouped[type] = [];
      }
      grouped[type].push(submission);
      return grouped;
    },
    {} as Record<SubmissionType, Submission[]>,
  );

  if (pendingSubmissions.length === 0) {
    return null;
  }

  return (
    <Container>
      <Accordion chevronPosition="right">
        {Object.entries(submissionsByType).map(([type, submissions]) => (
          <Accordion.Item value={type} key={type}>
            <Accordion.Control>
              <Group>
                <Text>{t(getSubmissionTypeLabel(type as SubmissionType))}</Text>
                <Badge>{submissions.length}</Badge>
              </Group>
            </Accordion.Control>
            <Accordion.Panel>
              <Stack gap="xs">
                {submissions.map((submission) => (
                  <Box key={submission._id || `submission-${Math.random()}`}>
                    <SubmissionItem submission={submission} role={role} />
                  </Box>
                ))}
              </Stack>
            </Accordion.Panel>
          </Accordion.Item>
        ))}
      </Accordion>
    </Container>
  );
};

export default SubmissionsList;
